<template>
  <mdb-side-nav-2
    :data="groupsContent"
    :value="true"
    side
    groups
    fixed-header
    color="white"
    :width="250"
    :sidenav-class="['deep-purple', 'darken-4']"
  >
    <div slot="header" class="mt-3 grey-text">
      <div class="text-center">
        <img
          width="170"
          src="../assets/img/white_logo_transparent.svg"
          class="img-fluid rounded z-depth-2 text-center"
        />
      </div>
      <h5 class="mt-4 ml-3">
        <strong>{{ $t("cityshoppari") }}</strong>
      </h5>
      <p class="ml-3">{{ updateName }}</p>
      <mdb-btn flat class="white-text" @click="logout">{{
        $t("logout")
      }}</mdb-btn>
      <hr class="mb-0" />
    </div>
  </mdb-side-nav-2>
</template>

<script>
import { mdbSideNav2, mdbBtn } from "mdbvue";

export default {
  name: "Sidenav",
  components: {
    mdbSideNav2,
    mdbBtn,
  },
  methods: {
    logout() {
      this.$root.$emit("session_failed");
    },
  },
  computed: {
    updateName() {
      return this.$store.getters.getName;
    },
  },
  data() {
    return {
      show: true,
      groupsContent: [
        {
          data: [
            {
              name: this.$t("home"),
              to: "/",
              icon: "home",
            },
            {
              name: this.$t("add_new_retailer"),
              to: "/addretailer",
              icon: "user-plus",
            },
            {
              name: this.$t("manage_retailers"),
              to: "/retailers",
              icon: "address-book",
            },
          ],
        },
        {
          data: [
            {
              name: this.$t("add_new_advertisement"),
              to: "/addadvertisement",
              icon: "cart-plus",
            },
            {
              name: this.$t("browse_advertisements"),
              to: "/advertisements",
              icon: "list",
            },
          ],
        },
        {
          data: [
            {
              name: this.$t("add_new_mobilepay_advertisement"),
              to: "/addmobilepayadvertisement",
              icon: "cart-plus",
            },
            {
              name: this.$t("browse_mobilepay_advertisements"),
              to: "/mobilepayadvertisements",
              icon: "list",
            },
          ],
        },
        {
          data: [
            {
              name: this.$t("add_new_notification"),
              to: "/addtimednotification",
              icon: "clock",
            },
            {
              name: this.$t("send_new_notification"),
              to: "/addimmediatenotification",
              icon: "paper-plane",
            },
            {
              name: this.$t("browse_notifications"),
              to: "/notifications",
              icon: "list",
            },
          ],
        },
        {
          data: [
            {
              name: this.$t("add_new_notifications_extra"),
              to: "/addnotificationsextra",
              icon: "clock",
            },
            {
              name: this.$t("browse_notifications_extra"),
              to: "/notificationsextra",
              icon: "list",
            },
          ],
        },
        {
          data: [
            {
              name: this.$t(
                "manage_notification_extra_unregistered_activation"
              ),
              to: "/managenotificationunregisteredactivation",
              icon: "clock",
            },
            {
              name: this.$t("manage_notification_extra_registered_activation"),
              to: "/managenotificationregisteredactivation",
              icon: "clock",
            },
            {
              name: this.$t(
                "manage_notification_extra_passived_registered_activation"
              ),
              to: "/managenotificationpassivedregisteredactivation",
              icon: "clock",
            },
          ],
        },
        {
          data: [
            {
              name: this.$t("forget_me"),
              to: "/forgetme",
              icon: "folder",
            },
          ],
        },
        {
          data: [
            {
              name: this.$t("manage_subcategorytypes"),
              to: "/subcategorytypes",
              icon: "folder",
            },
            {
              name: this.$t("manage_subcategories"),
              to: "/subcategories",
              icon: "folder",
            },
          ],
        },
        {
          data: [
            {
              name: this.$t("add_new_frontpage"),
              to: "/addfrontpage",
              icon: "cart-plus",
            },
            {
              name: this.$t("browse_frontpages"),
              to: "/frontpages",
              icon: "list",
            },
          ],
        } /*
        {
          data: [
            {
              name: this.$t("add_gift_card"),
              to: "/addgiftcard",
              icon: "gift"
            },
            {
              name: this.$t("manage_gift_cards"),
              to: "/managegiftcards",
              icon: "gift"
            }
          ]
        },*/,
        {
          data: [
            {
              name: this.$t("reports"),
              icon: "list",
              children: [
                {
                  name: this.$t("report_newsletter"),
                  to: "/reportnewsletter",
                  icon: "list",
                },
              ],
            },
          ],
        },
        {
          data: [
            {
              name: this.$t("statistics"),
              icon: "list",
              children: [
                {
                  name: this.$t("benefitcode_statistics"),
                  to: "/benefitcodestats",
                  icon: "list",
                },
                {
                  name: this.$t("customer_locations"),
                  to: "/customerlocations",
                  icon: "list",
                },
                {
                  name: this.$t("banners"),
                  to: "/banners",
                  icon: "list",
                },
                {
                  name: this.$t("promocode_statistics"),
                  to: "/userpromocodestats",
                  icon: "bar-chart",
                },
                {
                  name: this.$t("purchase_statistics"),
                  to: "/purchasestats",
                  icon: "bar-chart",
                },
                {
                  name: this.$t("ai_search_statistics"),
                  to: "/aisearchstats",
                  icon: "bar-chart",
                },
              ],
            },
          ],
        },
        {
          data: [
            {
              name: this.$t("manage_customers"),
              icon: "list",
              children: [
                {
                  name: this.$t("manage_member_phonenumbers"),
                  to: "/managememberphonenumbers",
                  icon: "phone",
                },
                {
                  name: this.$t("manage_member_ids"),
                  to: "/managememberids",
                  icon: "lock",
                },
                {
                  name: this.$t("manage_member_ids_together_with_customer"),
                  to: "/managememberidstogetherwithcustomer",
                  icon: "lock",
                },
                {
                  name: this.$t("manage_activation_codes"),
                  to: "/managepasswords",
                  icon: "key",
                },
                {
                  name: this.$t("import_activation_codes"),
                  to: "/importaccesscodes",
                  icon: "lock",
                },
                {
                  name: this.$t("manage_retailerchains"),
                  to: "/retailerchains",
                  icon: "link",
                },
                {
                  name: this.$t("manage_gameleo_keywords"),
                  to: "/gameleokeywords",
                  icon: "link",
                },
                {
                  name: this.$t("manage_userpromo_code_banners"),
                  to: "/userpromocodebanners",
                  icon: "link",
                },
                {
                  name: this.$t("manage_member_used_benefits"),
                  to: "/managememberusedbenefits",
                  icon: "link",
                },
                {
                  name: this.$t("promocodes"),
                  to: "/promocodes",
                  icon: "list",
                },
              ],
            },
          ],
        },
        {
          data: [
            {
              name: this.$t("management"),
              icon: "list",
              children: [
                {
                  name: this.$t("servicestatus"),
                  to: "/servicestatus",
                  icon: "list",
                },
                {
                  name: this.$t("manage_unionmembers"),
                  to: "/unionmembers",
                  icon: "list",
                },
              ],
            },
          ],
        },
      ],
    };
  },
};
</script>
